import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type {
  ReferenceRangeCriticality,
  ReferenceRanges,
} from "@/types/observations";

interface GetBMIResponse {
  bmi: number | null;
  effectiveDate: string | null;
  criticality: ReferenceRangeCriticality | null;
  referenceRanges: ReferenceRanges | null;
}

export const useBmi = (patientId?: string) => {
  return useApi<GetBMIResponse>({
    queryOptions: {
      enabled: Boolean(patientId),
      queryKey: QueryKeys.Patient.MedicalRecords.Vitals.BMI(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get<GetBMIResponse>(
          "/charting/vitals/bmi",
          {
            params: {
              patient_id: patientId,
            },
          },
        );
        return response.data;
      },
    },
  });
};
